module.exports = __webpack_public_path__ + "4321b8c975ae767dbf42daa3c90657ca.pdf";